/** Polish overlay for the IA restructure. */

const taxonomyPl = {
  family: 'Rodzina',
  families: {
    all_weather: 'Każda pogoda',
    directional: 'Kierunkowa',
    market_neutral: 'Neutralny rynkowo',
    momentum: 'Pęd',
    high_octane: 'Wysokoooktanowa',
    intraday: 'Intraday',
  },
  familyCopy: {
    all_weather: 'Zdywersyfikowane portfele reżimowe. Niższa beta akcyjna, wolniejsza ścieżka, balast dla portfela.',
    directional: 'Timing indeksów i makro. Udział w trendach, wyjście gdy zdrowie rynku się pogarsza.',
    market_neutral: 'Long/short akcji z betą bliską zera. Dywersyfikator, nie zakład kierunkowy.',
    momentum: 'Momentum akcji USA na wielu horyzontach. Podąża za siłą; zostaje w tyle przy mean-reversion.',
    high_octane: 'Levered risk-on / risk-off. Wyższy sufit, głębsze drawdowny.',
    intraday: 'Kontrakty Nasdaq intraday. Systematyczne wejścia w ramach każdej sesji, flat na jej zamknięciu. Nic nie przechodzi na kolejną sesję; przewaga żyje w reżimie zmienności.',
  },
};

export const iaPl = {
  nav: {
    portfolio: 'Portfel',
    research: 'Analizy',
    reports: 'Raporty',
    quantLab: 'Lab ilościowy',
    macroTerminal: 'Terminal',
    institutional: 'Instytucjonalne',
    more: 'Więcej',
    account: 'Konto',
    login: 'Zaloguj się',
    about: 'O mnie',
  },
  taxonomy: taxonomyPl,
  disclaimer: {
    label: 'Zastrzeżenie',
    body: 'Krzywe backtestu i researchu są materiałem edukacyjnym. To nie jest porada inwestycyjna ani rekomendacja. Wyniki historyczne nie gwarantują przyszłych rezultatów. Handel na żywo obejmuje koszty, których wykresy nie pokazują.',
  },
  strategyDetail: {
    compare: 'Porównaj w Performance',
    portfolio: 'Dodaj do portfela',
    subscribe: 'Raport tygodniowy',
    curveVsSpy: 'PRZELICZONE EQUITY vs INDEKS = 100',
    pros: 'Po co istnieje',
    cons: 'Kompromisy',
    deepDive: 'Pełna analiza',
  },
  strategies: {
    kicker: 'STRATEGIE SYSTEMATYCZNE',
    colStrategy: 'STRATEGIA',
    volShort: 'VOL',
    modelsCtaTitle: 'Portfele modelowe',
    modelsCtaBody: 'Gotowe mieszanki tych strategii, z tym samym silnikiem co konstruktor portfela.',
    openCard: 'Otwórz stronę →',
    intradayCardHint: 'W środku wybierasz ekspozycję: od 50 % do 500 % rachunku.',
    filterAll: 'Wszystkie',
    liveBadge: 'NA ŻYWO',
    expandGroup: 'Pokaż wszystkie {n} ▸',
    collapseGroup: 'Pokaż mniej ▴',
    seeFamily: 'Zobacz wszystkie {n} →',
    sizing: {
      title: 'Wielkość intraday',
      exposure: 'Ekspozycja',
      exposureHint: '{pct} rachunku na Nasdaq, gdy pozycja jest otwarta; liczba kontraktów wynika z wielkości rachunku.',
      wholeContracts: 'Kontrakty są całkowite: przy tej ekspozycji jeden kontrakt wymaga co najmniej {min} rachunku, a 100 000 $ handlowałoby dziś {n}.',
      grossNote: 'Bez prowizji i poślizgu.',
    },
    variant: {
      label: 'Wersja',
      standard: 'Standard',
      ucits: 'UCITS',
      cardHint: 'W środku: wersja Standard lub UCITS.',
      notes: {
        heimdall: 'UCITS to unijne ramy dla funduszy oferowanych inwestorom w Europie: ten sam sygnał, instrumenty dopuszczone w UCITS i limity koncentracji, w USD.',
        metis: 'UCITS to unijne ramy dla funduszy sprzedawanych inwestorom w Europie: ten sam sygnał, złoto i surowce najwyżej po 20 %, reszta w gotówce, w USD.',
      },
    },
    strategyDescriptions: {
      tyr: 'Rotacja all-weather',
      ares: 'Market timing',
      ascalafo: 'Dwie warstwy',
      deimos: 'Timing + ryzyko',
      fobos: 'Dwie warstwy + ryzyko',
      bes: 'Podążanie za trendem',
      janus: 'Market neutral',
      hraesvelgr: 'Agresywne all-weather',
      eos: 'Kontrakty Nasdaq intraday',
      artemis: 'Jedna transakcja na sesję',
      helios: 'Godzinowa kontynuacja trendu',
      hyperion: 'Trend dzienny, tylko long',
      horai: 'Zdywersyfikowany program intraday',
      theia: 'Program intraday, long i short',
      astraeus: 'Jedna decyzja dziennie, w obie strony',
      phaethon: 'Jedzie na impecie dnia',
      hemera: 'Po otwarciu, w obie strony',
      selene: 'Cierpliwa, tylko long',
      asteria: 'Raz w tygodniu, tylko w poniedziałek',
      aether: 'Szeroki program intraday',
      heimdall: 'Alokacja wg reżimu makro',
      metis: 'Rotacja wieloaktywowa według momentum',
    },
    strategyFullDescriptions: {
      tyr: 'TYR to zdywersyfikowana rotacja All-Weather. Rozkłada ryzyko na nieskorelowane reżimy gospodarcze i dostosowuje ekspozycje sygnałami własnymi. Nazwa od nordyckiego boga porządku i dyscypliny.',
      ares: 'ARES to systematyczny market timing. Czyta strukturalne zdrowie rynku jako całości — nie jednego tickera — i przełącza się między risk-on a risk-off. Zweryfikowany w 2008, 2020 i 2022. Live na Wikifolio.',
      ascalafo: 'ASCÁLAFO to dwuwarstwowy system timingu: niezależne sygnały muszą się zgodzić, zanim ekspozycja się obróci. Ta sama rodzina kierunkowa co ARES, z ciaśniejszymi wejściami wokół reżimów zmienności.',
      deimos: 'DEIMOS to wysokoooktanowa tuleja timingu. Ta sama logika zdrowia rynku co ARES, bardziej agresywna gdy trendy są czyste, twardsze drawdowny gdy nie.',
      fobos: 'FOBOS dodaje overlay zmienności na lewarowany timing. Redukuje ryzyko, gdy reżimy zmienności stają się wrogie, i wraca, gdy się uspokajają.',
      bes: 'BES to momentum akcji na wielu horyzontach. Zostawia nazwy, które wyprzedzają szeroki rynek na kilku skalach czasu, i obcina te, które tego nie robią.',
      janus: 'JANUS to long/short market-neutral selection. Tygodniowy rebalancing, beta bliska zera: dywersyfikator, nie zakład kierunkowy.',
      hraesvelgr: 'HRÆSVELGR to bardziej agresywny bliźniak TYR w rodzinie All Weather. Ta sama dyscyplina reżimów, większy apetyt na wzrost i szybszy zwrot do obrony, gdy momentum gaśnie.',
      eos: 'EOS bierze nazwę od greckiej bogini świtu. Handluje kontrakty na Nasdaq w pierwszych godzinach sesji: systematyczne, potwierdzone wejście w kierunku, w którym skłania się dzień, stały stop i cel, flat przed zamknięciem. Zaudytowana w YGGDRASIL: Sharpe blisko 1,5, beta zero do indeksu. Pokazana przy ekspozycji 300 %, bez prowizji.',
      artemis: 'ARTEMIS bierze nazwę od greckiej bogini łuczniczki: jedna strzała na sesję. Jedna systematyczna pozycja na kontraktach Nasdaq na początku sesji, long lub short, ze stałym stopem i celem, flat na zamknięciu; nie handluje w główne dni makro. Zaudytowana przy jednym stałym kontrakcie: Sharpe 1,3, beta zero. Pokazana przy ekspozycji 300 %, bez prowizji.',
      hyperion: 'HYPERION bierze nazwę od tytana światła, tego, który czuwa z góry. Handluje kontraktami na Nasdaq intraday i tylko long: czeka, aż dzień odkryje karty, dołącza ze stałym stopem i celem i wychodzi przed zamknięciem. Zaudytowana w YGGDRASIL przy jednym stałym kontrakcie: Sharpe 1,4, beta zero. Pokazana przy ekspozycji 300 %, bez prowizji.',
      helios: 'HELIOS bierze nazwę od słońca wędrującego po niebie: podąża drogą, którą obiera dzień. Raz na godzinę sprawdza, czy kontrakty na Nasdaq dryfują z przekonaniem w jednym kierunku, i jeśli tak, dołącza do tego ruchu ze stałym stopem i celem, najwyżej kilka razy na sesję, zawsze flat na zamknięciu. Zaudytowana przy jednym stałym kontrakcie: Sharpe 1,1, beta zero. Pokazana przy ekspozycji 300 %, bez prowizji.',
      horai: 'HORAI bierze nazwę od greckich bogiń godzin, które dzielą między siebie dzień. Zdywersyfikowany program intraday na kontraktach Nasdaq: rachunek rozłożony na niezależne systematyczne decyzje podejmowane w różnych momentach sesji, wszystkie flat na zamknięciu. Te decyzje są słabo skorelowane, więc zachowuje większość zwrotu przy ułamku obsunięcia pojedynczego podejścia. Pokazana przy ekspozycji 300 %, bez prowizji.',
      theia: 'THEIA bierze nazwę od tytanidy wzroku, tej, która widzi cały dzień naraz. Systematyczny program intraday na kontraktach Nasdaq, long i short, z kilkoma decyzjami w ciągu sesji i niczym otwartym przez noc. Zaudytowana w YGGDRASIL. Pokazana przy ekspozycji 300 %, bez prowizji.',
      astraeus: 'ASTRAEUS bierze nazwę od tytana zmierzchu, ojca gwiazd i czterech wiatrów. Handluje kontraktami na Nasdaq intraday, long lub short, z najwyżej jedną decyzją dziennie i niczym otwartym przez noc. Zaudytowana w YGGDRASIL przy jednym stałym kontrakcie: Sharpe 1,4, beta zero. Pokazana przy ekspozycji 300 %, bez prowizji.',
      phaethon: 'PHAETHON bierze nazwę od syna Heliosa, który na jeden dzień wziął rydwan słońca. Handluje kontraktami na Nasdaq intraday, long lub short, jadąc na impecie dnia ze stałym stopem i wychodząc przed zamknięciem. Zaudytowana w YGGDRASIL przy jednym stałym kontrakcie: Sharpe 1,4, beta zero. Pokazana przy ekspozycji 300 %, bez prowizji.',
      hemera: 'HEMERA bierze nazwę od bogini dnia, córki Nocy, która każdego ranka przynosi światło. Handluje kontraktami na Nasdaq intraday, long lub short, gdy otwarcie już odkryło karty, ze stałym stopem i celem, bez pozycji na zamknięciu. Zaudytowana w YGGDRASIL przy jednym stałym kontrakcie: Sharpe 1,3, beta zero. Pokazana przy ekspozycji 300 %, bez prowizji.',
      selene: 'SELENE bierze nazwę od tytanidy księżyca, siostry Heliosa i Eos. Handluje kontraktami na Nasdaq intraday i tylko long, kilka dni w miesiącu, które sama wybiera, i jest bez pozycji na zamknięciu. Zaudytowana w YGGDRASIL przy jednym stałym kontrakcie: nieprzyjęta, jedna twarda reguła niespełniona. Pokazana przy ekspozycji 300 %, bez prowizji.',
      asteria: 'ASTERIA bierze nazwę od tytanidy spadających gwiazd, siostry Leto, która stała się wyspą Delos. Handluje kontraktami na Nasdaq tylko long, raz w tygodniu: kupuje w niedzielę wieczorem na sesję poniedziałkową i wychodzi przed poniedziałkowym zamknięciem, na stałym celu albo o ustalonej godzinie, bez stopu. Zaudytowana w YGGDRASIL przy jednym stałym kontrakcie: przyjęta, Sharpe 1,3, żadna twarda reguła niespełniona; regułę minimalnej próby (300 transakcji) wyłączono decyzją właściciela, bo handluje raz w tygodniu. Pokazana przy ekspozycji 300 %, bez prowizji.',
      aether: 'AETHER bierze nazwę od jasnego górnego powietrza, którym oddychają bogowie, ponad pogodą. Systematyczny program intraday na kontraktach Nasdaq, long i short, z kilkoma decyzjami w ciągu sesji i flat na każdym zamknięciu. Pokazana przy ekspozycji 300 %, bez prowizji.',
      heimdall: 'HEIMDALL bierze nazwę od strażnika Bifröstu, który widzi i słyszy wszystko i dmie w Gjallarhorn, gdy nadchodzi zmiana. Co miesiąc odczytuje wzrost i inflację w USA z danych w takiej postaci, w jakiej je wtedy opublikowano, zamienia je na prawdopodobieństwa czterech reżimów i rozkłada portfel między akcje, obligacje skarbowe USA, TIPS, złoto, surowce i bony skarbowe; tygodniowa nakładka ryzyka zmniejsza ekspozycję, gdy rośnie zmienność lub napięcie na rynku. Dwie wersje, ten sam sygnał: Standard i UCITS. Wersję Standard zaudytowano w YGGDRASIL: przyjęta.',
      metis: 'METIS nosi imię tytanidy mądrej rady, pierwszej żony Zeusa i matki Ateny. W ostatnim dniu sesyjnym każdego miesiąca trzyma trzy z ośmiu rynków (akcje, obligacje skarbowe USA, złoto, surowce, nieruchomości), które najbardziej wzrosły w ciągu sześciu miesięcy, tylko jeśli są na plusie, a w przeciwnym razie gotówkę; hamulec zmienności zmniejsza ekspozycję powyżej 15 %. Dwie wersje, ten sam sygnał: Standard i UCITS. Wersja Standard została zbadana przez YGGDRASIL: przyjęta. Wersja UCITS nie została przyjęta (dwie twarde reguły niespełnione) i jest publikowana decyzją właściciela.',
    },
  },
  home: {
    ticker: {
      subtitle: 'Research systematyczny · live track record',
    },
    hero: {
      lead: 'Dwadzieścia dwie strategie systematyczne. Kilka działa na żywo od lat — możesz je śledzić na Wikifolio, Darwinex i eToro. Na każdej stronie jej liczby.',
      live: 'Live track record',
      ctaReports: 'Raporty tygodniowe',
      ctaTerminal: 'Otwórz Terminal',
    },
    regimeTeaser: {
      kicker: 'WŁASNY',
      title: 'Detektor reżimu HMA',
      body: 'Sześć ukrytych modeli Markowa. Jeden kompozyt, walk-forward. Żywy desk wokół. Subskrybuj, aby otworzyć.',
      cta: 'Zobacz Terminal',
    },
    featured: {
      subtitle: 'Kierunkowa · zdrowie rynku',
      cta: 'Otwórz ARES →',
      description: 'Market timing z kompozytu zdrowia rynku: zostań zainwestowany, gdy warunki to utrzymują, zejdź z drogi, gdy nie. Live na Wikifolio.',
    },
    families: {
      title: 'Sześć rodzin',
      subtitle: 'Ten sam proces researchu, różne zadania w portfelu. Otwórz rodzinę, aby zobaczyć strategie.',
    },
    snapshot: {
      label: 'EQUITY, TEN SAM START',
      title: 'TYR wobec indeksów akcyjnych',
      hint: 'Ta sama data startu, przeliczone do 100. Skala log, żeby TYR i indeksy były razem czytelne.',
      cta: 'Otwórz Performance',
    },
    products: {
      title: 'Na co możesz się zapisać',
      reportsKicker: 'ANALIZY',
      reportsTitle: 'Raporty tygodniowe',
      reportsBody: 'Metodologia, ewolucja portfela i tydzień, który właśnie się zamknął — per strategia lub w pakiecie.',
      reportsCta: 'Zobacz plany',
      terminalKicker: 'REŻIM',
      terminalTitle: 'HMA Terminal',
      terminalBody: 'Własny sześcioczynnikowy detektor reżimu HMA — plus żywy desk wokół. Otwórz.',
      terminalCta: 'Otwórz Terminal',
    },
    instTeaser: {
      title: 'Mandaty, nie karta produktu',
      body: 'Projekt strategii, research reżimu i overlay ryzyka dla funduszy, family office i desków, które potrzebują kogoś, kto zbuduje.',
      cta: 'Zobacz stronę mandatów',
    },
  },
  insights: {
    title: 'Analizy',
    subtitle: 'Notatki ilościowe na Substack. Kalendarz i silnik reżimu są w Terminalu.',
    marketContext: 'Kontekst rynkowy',
    marketContextHint: 'Pełny reżim, STIR i narzędzia płynności są w Terminalu.',
    openTerminal: 'Otwórz Terminal',
    whereToInvestSubtitle: 'Kilka strategii działa na żywo, z prawdziwym track recordem na regulowanych platformach.',
    readOnSubstack: 'Czytaj na Substack →',
    strategyNamed: 'Strategia {name}',
  },
  weeklyReports: {
    revealPrice: 'Zobacz cenę i subskrybuj →',
    universeLabel: 'Uniwersum',
    popular: 'Popularne',
    universe: {
      diversified: 'Zdywersyfikowane ETF-y',
      index: 'ETF-y indeksowe',
      equities: 'Akcje notowane',
      leveraged: 'ETF-y z dźwignią',
      futures: 'Kontrakty na Nasdaq',
    },
    cards: {
      TYR: 'Rotacja All-Weather — tygodniowy raport researchowy',
      HRAESVELGR: 'Agresywniejsza rotacja All Weather — tygodniowy raport researchowy',
      ARES: 'Timing makro i ochrona — tygodniowy raport researchowy',
      JANUS: 'Long/short market-neutral — tygodniowy raport researchowy',
      BES: 'Momentum akcji na wielu horyzontach — tygodniowy raport researchowy',
      ASCALAFO: 'Timing makro z overlayem zmienności — tygodniowy raport researchowy',
      DEIMOS: 'Agresywny timing makro — tygodniowy raport researchowy',
      FOBOS: 'Lewarowany timing z overlayem zmienności — tygodniowy raport researchowy',
      EOS: 'Kontrakty Nasdaq intraday — tygodniowy raport researchowy',
      ARTEMIS: 'Jedna transakcja na sesję na kontraktach Nasdaq — tygodniowy raport researchowy',
      HELIOS: 'Godzinowa kontynuacja trendu na kontraktach Nasdaq — tygodniowy raport researchowy',
      HYPERION: 'Trend dzienny na kontraktach Nasdaq, tylko long — tygodniowy raport researchowy',
      HORAI: 'Zdywersyfikowany program intraday na kontraktach Nasdaq — tygodniowy raport researchowy',
      THEIA: 'Program intraday na kontraktach Nasdaq, long i short — tygodniowy raport researchowy',
      ASTRAEUS: 'Jedna decyzja dziennie na kontraktach Nasdaq, long i short — tygodniowy raport researchowy',
      PHAETHON: 'Momentum intraday na kontraktach Nasdaq, long i short — tygodniowy raport researchowy',
      HEMERA: 'Po otwarciu na kontraktach Nasdaq, long i short — tygodniowy raport researchowy',
      SELENE: 'Cierpliwe dni tylko long na kontraktach Nasdaq — tygodniowy raport researchowy',
      ASTERIA: 'Poniedziałkowy long na kontraktach Nasdaq, raz w tygodniu — tygodniowy raport researchowy',
      AETHER: 'Szeroki program intraday na kontraktach Nasdaq — tygodniowy raport researchowy',
      HEIMDALL: 'Alokacja wieloaktywowa wg reżimu makro, Standard i UCITS — tygodniowy raport researchowy',
      METIS: 'Rotacja wieloaktywowa według momentum, Standard i UCITS — tygodniowy raport badawczy',
    },
    disclaimerLabel: 'Zastrzeżenie',
    disclaimer: 'Te raporty służą wyłącznie celom informacyjnym i edukacyjnym. Opisują metodologię, modele i ewolucję portfela każdej strategii. NIE stanowią sygnałów tradingowych, porady inwestycyjnej ani spersonalizowanych rekomendacji. Wyniki historyczne nie gwarantują przyszłych rezultatów. Zrób własny research i skonsultuj się z licencjonowanym doradcą przed inwestycją.',
    notAvailable: 'Ta strategia nie jest jeszcze dostępna do zakupu',
    bundleNotAvailable: 'Pakiet nie jest jeszcze dostępny do zakupu',
    checkoutFailed: 'Nie udało się utworzyć sesji płatności',
    checkoutStartFailed: 'Nie udało się rozpocząć płatności. Spróbuj ponownie.',
  },
  checkout: {
    missingPrice: 'Ten produkt nie jest jeszcze dostępny — brak ceny Stripe.',
    checkoutFailed: 'Nie udało się rozpocząć płatności',
    checkoutError: 'Błąd płatności: {message}',
    noSubscription: 'Brak aktywnej subskrypcji',
    portalFailed: 'Nie udało się otworzyć zarządzania subskrypcją. Spróbuj ponownie.',
  },
  contact: {
    fillAll: 'Wypełnij wszystkie pola',
    sent: 'Wiadomość wysłana. Odpowiem wkrótce.',
    sendError: 'Błąd wysyłki. Spróbuj ponownie.',
    connectionError: 'Błąd połączenia. Spróbuj później.',
    sending: 'Wysyłanie…',
    methodLabel: 'Sposób kontaktu',
    methodHint: 'Użyj formularza, aby wysłać wiadomość. Zwykle odpowiadam w ciągu 24–48 godzin.',
  },
  common: {
    present: 'Dziś',
  },
  performancePage: {
    kicker: 'ANALITYKA',
    title: 'Wyniki',
    lead: 'Porównaj strategie ze sobą i z indeksami. Sharpe, drawdown, korelacja i ryzyko, z opublikowanych krzywych.',
    dateRange: 'Zakres dat',
    dateHint: 'Każda seria jest przycinana do nakładających się dat w tym zakresie i przeliczana do 100 we wspólnym starcie.',
    equity: 'Krzywe kapitału',
    logScale: 'Skala log',
    showRegime: 'Nakładka reżimu rynku',
    regimeHint: 'Kolor tła to kompozyt sześciu czynników (risk-on → risk-off). To odczyt rynkowy, nie sygnał strategii.',
    regimeOn: 'Risk-on',
    regimeNeutral: 'Neutralny',
    regimeCautious: 'Ostrożny',
    regimeOff: 'Risk-off',
    rollingSharpe: 'Ślizgający Sharpe',
    months: '{n} mies.',
    drawdown: 'Drawdown',
    underwater: 'pod wodą',
    correlation: 'Korelacja',
    correlationHint: 'Stopy miesięczne · Pearson',
    metrics: 'Metryki porównawcze',
    strategies: 'Strategie',
    benchmarks: 'Benchmarki',
    selectAll: 'Zaznacz wszystkie',
    clear: 'Wyczyść',
    needTwo: 'Wybierz co najmniej dwie serie, aby zobaczyć korelacje',
    needOne: 'Wybierz co najmniej jedną serię, aby zobaczyć metryki',
    needOneEquity: 'Wybierz co najmniej jedną strategię lub benchmark',
    needOneDrawdown: 'Wybierz co najmniej jedną serię, aby zobaczyć drawdown',
    needOneSharpe: 'Wybierz co najmniej jedną serię, aby zobaczyć ślizgający Sharpe',
    rebased: 'Przeliczone do 100',
    rebasedFrom: 'Przeliczone do 100 · {date}',
    series: 'Serie',
    totalReturn: 'Całkowity zwrot',
    volatility: 'Zmienność',
    upMonths: '% miesięcy na plusie',
    metricsNote: 'Metryki liczone są na wspólnym oknie wybranych serii',
    metricsNoteRange: 'w zaznaczonym zakresie dat',
    metricsNoteAnnual: 'Sharpe i Sortino używają dziennych nadwyżkowych stóp zwrotu ponad 3-miesięczne bony skarbowe USA, anualizowanych przy 252 sesjach (krzywe tygodniowe: stopy tygodniowe, 52).',
    maxPreset: 'Maks.',
    typeStrategy: 'strategia',
    typeBenchmark: 'benchmark',
  },
  portfolioPage: {
    kicker: 'KONSTRUKTOR PORTFELA',
    title: 'Zbuduj swój portfel',
    lead: 'Łącz strategie HMA z własnymi wagami, wybierz częstotliwość rebalansowania i zrób backtest portfela wobec głównych benchmarków.',
    presets: 'Szybkie presety',
    loadModel: 'Wczytaj portfel modelowy',
    findProfile: 'Znajdź mój profil ryzyka',
    optimizing: 'Optymalizacja…',
    optimize: 'Optymalizuj pod max. Sharpe',
    optimizeFailed: 'Optymalizacja nie powiodła się — spróbuj innej częstotliwości rebalansu.',
    components: 'Składniki portfela',
    select: 'Wybierz…',
    addComponent: 'Dodaj składnik',
    totalOk: 'Suma: {n}%',
    totalUnder: 'Suma: {n}% — zostaje {left}%',
    totalOver: 'Suma: {n}% — przekracza 100%',
    autoBalance: 'Auto-balans',
    rebalancing: 'Częstotliwość rebalansu',
    rebalanceHint: 'Rebalancing okresowo resetuje wagi do Twojej alokacji docelowej.',
    monthly: 'Miesięcznie',
    quarterly: 'Kwartalnie',
    annually: 'Rocznie',
    never: 'Nigdy (kup i trzymaj)',
    logScale: 'Skala log',
    rebased: 'Przeliczone do 100',
    calculate: 'Oblicz portfel',
    copied: 'Skopiowano!',
    copyLink: 'Kopiuj link',
    models: 'Portfele modelowe',
    modelsHint: 'Wczytaj gotową mieszankę i oblicz. Albo zbuduj własną po lewej.',
    myPortfolio: 'Mój portfel',
    allocation: 'Alokacja',
    backtestRange: 'Zakres backtestu',
    years: '{n} lat',
    rebalanced: 'Rebalancing: {freq}',
    equityCurve: 'Krzywa kapitału',
    fullMetrics: 'Pełne metryki',
    valueBase: 'Wartość (baza 100)',
    returnPct: 'Zwrot (%)',
    sharpeRatio: 'Wskaźnik Sharpe',
    maxDrawdown: 'Maks. drawdown',
    ddDuration: 'Czas DD',
    bestYear: 'Najlepszy rok',
    worstYear: 'Najgorszy rok',
    posMonths: 'Mies. na plusie',
    compareVs: 'Porównaj z',
    benchmarksHint: 'Linie przerywane to indeksy referencyjne. Nie wchodzą w skład portfela.',
  },
  terminalLanding: {
    badge: 'WŁASNY DETEKTOR REŻIMU',
    title: 'Detektor reżimu rynku — zbudowany tutaj.',
    lead: 'Sześć ukrytych modeli Markowa składa się w jeden kompozyt, od risk-on do risk-off. Wokół niego żywy desk: makro, funding, wewnętrzne. Otwieraj go codziennie.',
    price: '10,99 € / miesiąc.',
    ctaSignIn: 'Zaloguj się, aby subskrybować',
    ctaOpen: 'Otwórz Terminal →',
    ctaBusy: 'Przekierowanie…',
    ctaUnlock: 'Odblokuj za 10,99 € / miesiąc',
    seeInside: 'Zobacz detektor',
    subscribed: 'Masz subskrypcję — dostęp jest aktywny.',
    liveNow: 'KOMPOZYT NA ŻYWO',
    liveAsOf: 'na {date}',
    regimeEyebrow: 'SILNIK',
    regimeTitle: 'Detektor reżimu HMA',
    regimeLead: 'To proprietaryjne jądro Terminala. Sześć niezależnych gaussowskich HMM — zmienność, trend, szerokość, cykl, płynność, wycena — każdy wnioskuje stan ukryty i ważone ryzyko. Ich średnia to kompozyt. Każdy dzień walk-forward: tylko informacja z tego dnia. To nie ticket. To odczyt taśmy.',
    regimePoints: [
      { t: 'Własny', d: 'Zaprojektowany i prowadzony tutaj. Ten sam silnik, którym HMA czyta rynek — teraz na Twoim ekranie.' },
      { t: 'Sześć czynników', d: 'Zmienność, trend, szerokość, cykl, płynność, wycena. Niezależne modele, jeden kompozyt.' },
      { t: 'Walk-forward', d: 'Bez look-ahead. Każdy dzień filtrowany na własnej przeszłości. Historia, której można zaufać.' },
      { t: 'Kompozyt i ekspozycja', d: 'Liczba od 0 (risk-on) do 1 (risk-off). Sugerowana ekspozycja = 1 − kompozyt, z histerezą 5 dni.' },
    ],
    shotsEyebrow: 'DESK',
    shotsTitle: 'Co otwierasz po subskrypcji',
    shots: [
      { t: 'Detektor reżimu', d: 'Kompozyt, tablica sześciu czynników, historia przyczynowa.' },
      { t: 'Taśma płynności', d: 'Płynność netto, stawki overnight, krzywa.' },
      { t: 'Monitor STIR', d: 'Korytarz, rezerwy, stres fundingowy.' },
      { t: 'Dashboard makro', d: 'Rentowności, inflacja, praca, kredyt, stres.' },
      { t: 'Wewnętrzne rynku', d: 'Uczestnictwo pod indeksem.' },
      { t: 'Prywatne repo', d: 'Stawki overnight, wolumeny, użycie okien.' },
    ],
    lockedEyebrow: 'ZABLOKOWANE',
    lockedTitle: 'Więcej paneli, za kłódką',
    lockedHint: 'Subskrybuj, aby otworzyć eksplorator czynników, kredyt, okna i alerty szerokości — nie tylko okładki.',
    lockedCta: 'Odblokuj',
    lockedShots: [
      { t: 'Eksplorator czynników' },
      { t: 'Kredyt i stres' },
      { t: 'Użycie okien' },
      { t: 'Alerty szerokości' },
      { t: 'Przewodnik terenowy' },
      { t: 'Funding overnight' },
      { t: 'Historia czynników' },
      { t: 'Płynność z bliska' },
    ],
    previewKicker: 'PODGLĄD NA ŻYWO',
    previewTitle: 'Prawdziwy terminal działa pod spodem. Subskrybuj, aby zdjąć rozmycie.',
    insideEyebrow: 'CO DOSTAJESZ',
    insideTitle: 'Detektor, potem cały desk',
    features: [
      { t: 'Detektor reżimu HMA', d: 'Sześć niezależnych gaussowskich HMM. Jeden kompozyt od risk-on do risk-off. Zbudowany tutaj, nie licencjonowany.' },
      { t: 'Kompozyt i ekspozycja', d: 'Liczba od 0 do 1, sugerowana ekspozycja 1 − kompozyt i histereza 5 dni, żeby etykieta nie migała.' },
      { t: 'Historia walk-forward', d: 'Każdy dzień oceniany informacją z tego dnia — bez look-ahead. Ścieżka reżimu do backtestu.' },
      { t: 'Eksplorator czynników', d: 'Otwórz dowolny czynnik: stan na żywo, ścieżka ryzyka i wskaźniki zasilające model.' },
      { t: 'Taśma płynności', d: 'Płynność netto systemu vs indeks, stawki overnight i krzywa 2s10s — pływ, na jednym ekranie.' },
      { t: 'Monitor STIR', d: 'Korytarz overnight, ogony, rezerwy vs reverse-repo, spready fundingowe i aktywa money-market — gdzie stres widać najpierw.' },
      { t: 'Wewnętrzne rynku', d: 'Moverzy 4%, ratio 5- i 10-dniowe, szczyty/dołki 25-dniowe i thrust 13/34 — nie tylko indeks.' },
      { t: 'Dashboard makro', d: 'Pełna krzywa, inflacja i praca, kredyt HY vs IG, indeksy warunków finansowych, dolar i ropa.' },
      { t: 'Prywatne repo', d: 'Stawki i wolumeny overnight tri-party, DVP i GCF, obok użycia okien i kontrahentów.' },
      { t: 'Przewodnik terenowy', d: 'Jasne notatki do każdej serii: co oznacza, dlaczego się rusza i jak ją czytać.' },
    ],
    howEyebrow: 'JAK TO DZIAŁA',
    howTitle: 'Detektor ocenia dzień. Ty go czytasz.',
    steps: [
      { n: '01', t: 'Sześć modeli ocenia dziś', d: 'Każdy czynnik wnioskuje stan ukryty i ryzyko w [0,1] — ściśle przyczynowo, bez look-ahead.' },
      { n: '02', t: 'Jeden kompozyt', d: 'Średnia równo ważona, histereza, sugerowana ekspozycja. Od risk-on do risk-off, w jednej liczbie.' },
      { n: '03', t: 'Otwierasz Terminal', d: 'Detektor, historia, eksplorator i reszta desku — gotowe po zalogowaniu.' },
    ],
    membership: 'SUBSKRYPCJA',
    perMonth: '/ miesiąc',
    cancel: 'Anuluj w każdej chwili · rozliczenie miesięczne',
    bullets: [
      'Własny sześcioczynnikowy detektor reżimu',
      'Kompozyt na żywo i sugerowana ekspozycja',
      'Historia reżimu walk-forward',
      'Eksplorator czynników',
      'Panele makro, STIR, wewnętrzne i repo',
      'Przewodnik terenowy przy każdej serii',
      'Aktualizacje codziennie',
    ],
    faqEyebrow: 'FAQ',
    faqTitle: 'Warto wiedzieć',
    faq: [
      { q: 'Za co dokładnie płacę?', a: 'Dostęp na żywo do Terminala: własny detektor reżimu HMA, eksplorator czynników, historia przyczynowa i reszta desku — aktualizowane codziennie.' },
      { q: 'Czym jest detektor reżimu?', a: 'Sześcioczynnikowy silnik hidden-Markov zbudowany tutaj. Nie mówi, co kupić. Mówi stan ryzyka rynku, każdego dnia, bez look-ahead.' },
      { q: 'Czy to porada inwestycyjna?', a: 'Nie. To narzędzie researchu i monitoringu. Wszystko jest edukacyjne i informacyjne — nie rekomendacja kupna ani sprzedaży.' },
      { q: 'Czy mogę anulować w każdej chwili?', a: 'Tak. To miesięczna subskrypcja, którą anulujesz jednym kliknięciem z konta; dostęp trwa do końca okresu rozliczeniowego.' },
    ],
    disclaimer: 'Terminal hmaquant to narzędzie ilościowego researchu i monitoringu, wyłącznie edukacyjne i informacyjne. To nie jest porada inwestycyjna i nic w nim nie stanowi rekomendacji kupna lub sprzedaży jakiegokolwiek papieru.',
  },
  reportsFaq: {
    title: 'FAQ',
    items: [
      { q: 'Co kupuję?', a: 'Tygodniowy raport researchowy o tej strategii: metodologia, ewolucja portfela i poprzedni tydzień. To nie jest ticket transakcyjny ani spersonalizowana porada.' },
      { q: 'Czy mogę anulować?', a: 'Tak. Zarządzaj subskrypcją z konta. Dostęp trwa do końca okresu rozliczeniowego.' },
      { q: 'Czym jest plan roczny?', a: 'Dziesięć miesięcy płatne, dwa miesiące gratis. Ten sam raport, faktura roczna.' },
      { q: 'Czy pakiet obejmuje Terminal?', a: 'Pakiet obejmuje dwadzieścia dwa raporty strategii i notatki makro. Terminal to osobny produkt za 10,99 €.' },
    ],
  },
  footer: {
    tagline: 'Research systematyczny. Dwadzieścia dwie strategie, jeden proces.',
    intradayNote: 'Krzywe strategii intraday na kontraktach (EOS, ARTEMIS, HELIOS, HYPERION, HORAI, THEIA, ASTRAEUS, PHAETHON, HEMERA, SELENE, ASTERIA, AETHER) są pokazane bez prowizji i poślizgu, przy stałej ekspozycji 300 % rachunku (kontrakty podążają za wielkością rachunku), na backteście odtworzonym z audytu YGGDRASIL.',
  },
  accountHub: {
    reports: 'Moje raporty',
    terminal: 'Terminal',
    lab: 'Lab ilościowy',
  },
  quantLabPage: {
    kicker: 'SANDBOX',
    blurb: 'Symulacje edukacyjne — GBM, mean reversion, ukryty Markov, greeks. To nie jest żywy desk.',
    openTerminal: 'Otwórz Terminal',
    versionBar: 'QUANT LAB v1.0 · HMA QUANT STRATEGIES',
  },
  terminalChrome: {
    lab: 'Sandbox edukacyjny · to nie jest porada inwestycyjna',
    modules: '{n} modułów',
  },
  institutionalPage: {
    kicker: 'MANDATY',
    heroTitle: 'Zbudowane pod Twój book. Nie katalog produktów.',
    heroBody: 'HMA bierze instytucjonalne mandaty researchu — projekt systematyczny, pracę nad reżimem i overlay ryzyka — dla funduszy, family office i desków, które potrzebują kogoś, kto zbuduje, a nie kolejnego newslettera.',
    ctaPrimary: 'Wyślij brief',
    ctaSecondary: 'Jak pracujemy',
    proofKicker: 'PUBLICZNIE',
    proof: [
      { value: '12', label: 'strategie systematyczne na żywo' },
      { value: 'Live', label: 'Track record na Wikifolio, Darwinex i eToro' },
      { value: '6 HMM', label: 'własny silnik reżimu, walk-forward' },
      { value: 'Desk', label: 'Fizyka, finanse ilościowe, buy-side i broker' },
    ],
    forTitle: 'Kto powinien napisać',
    forBody: 'Jeśli pytanie już znasz, scope da się domknąć na callu. Jeśli szukasz broszury vendora, to zła strona.',
    for: [
      { title: 'Family office / allocator', body: 'Sleeve, który musi zasłużyć na miejsce obok reszty booka. Projektujemy proces, budżet ryzyka i kill-switch — nie pitch deck z backtestów.' },
      { title: 'CIO / ryzyko', body: 'Overlay reżimu, protokół drawdownu albo niezależny odczyt, czy obecny book nadal jest tym, który myślałeś, że masz.' },
      { title: 'Desk systematyczny', body: 'Moduł, którego nie chcesz staffować wewnątrz: research sygnału, walk-forward, spec monitoringu albo druga para oczu na żywy proces.' },
    ],
    workTitle: 'Mandaty, które bierzemy',
    workBody: 'Publiczny site to work sample. Mandat idzie dalej: Twoje dane, Twoje ograniczenia, Twój book.',
    work: [
      { title: 'Projekt strategii systematycznych', body: 'Od hipotezy do procesu, który można odpalić. Uniwersum, sygnały, założenia egzekucji, walk-forward i tryby awarii spisane zanim kapitał jest w ryzyku.', tag: 'Nowy sleeve · rebuild' },
      { title: 'Reżim i research makro', body: 'Stos sześciu HMM z Terminala, wyspecyfikowany pod Twój book: kiedy dokładać ryzyko, kiedy ciąć, co znaczy neutralne dla Ciebie.', tag: 'Overlay · timing' },
      { title: 'Overlaye ryzyka i protokoły drawdownu', body: 'Kill-switche, vol targeting, ścieżki stress i reguły, które CIO obroni na komitecie — nie VaR na slajdzie.', tag: 'Ryzyko · overlay' },
      { title: 'Konstrukcja portfela', body: 'Jak elementy siadają razem. Budżety ryzyka, reżimy korelacji i co robić, gdy dwa dywersyfikatory zaczynają iść jak jeden.', tag: 'Family office · multi-strategy' },
      { title: 'Research na retainerze', body: 'Tydzień albo miesiąc: notatki, diagnostyka i ktoś, kto już zna book. Bliżej desku niż PDF-a consultingowego.', tag: 'Ciągły' },
    ],
    processTitle: 'Jak przebiega zlecenie',
    processBody: 'Krótki scope, założenia na piśmie, praca zostaje u Ciebie.',
    process: [
      { n: '01', title: 'Brief', body: 'Wysyłasz pytanie, ograniczenia i co znaczy zrobione. Mówimy tak, nie, albo jeszcze nie.' },
      { n: '02', title: 'Scope', body: 'Krótka nota: deliverable, dane, których potrzebujemy, timeline, fee. Bez wyprawy wędkarskiej.' },
      { n: '03', title: 'Build', body: 'Research w otwarte z Tobą. Kod, wykresy i założenia tak spisane, żeby ktoś inny mógł je odpalić ponownie.' },
      { n: '04', title: 'Oddanie', body: 'Praca zostaje u Ciebie. Opcjonalny retainer, żeby proces żył, gdy reżim się zmienia.' },
    ],
    deliverTitle: 'Z czym odchodzisz',
    deliver: [
      { title: 'Zapisany proces', body: 'Nie czarna skrzynka. Sygnały, dane i reguły, kiedy wolno handlować.' },
      { title: 'Paczka researchu', body: 'Walk-forward, przypadki awarii i wykresy, które komitet naprawdę przeczyta.' },
      { title: 'Kod, jeśli chcesz', body: 'Reprodukowalne notebooki albo mały serwis. Do odpalenia u Ciebie.' },
      { title: 'Spec operacyjny', body: 'Co monitorować, co zabić, kto dostaje alert.' },
    ],
    notTitle: 'Czym to nie jest',
    notItems: [
      'Nie trzymamy Twojego AUM. Live track record jest na regulowanych platformach — dowód procesu, nie zbiórka do funduszu.',
      'Nie sprzedajemy zrzutu sygnałów ani modelu bez właściciela.',
      'Nie bierzemy każdego briefu. Jeśli to newsletter, produkt jest na Raportach. Jeśli problem desku — napisz.',
    ],
    sampleTitle: 'Publiczny work sample',
    sampleBody: 'Strategie, Wyniki i Terminal to to, co już odpalamy. Mandat to ten sam rzemiosło, wyspecyfikowane pod Ciebie.',
    samples: [
      { to: '/strategies', label: 'Dwadzieścia dwie strategie' },
      { to: '/performance', label: 'Wyniki' },
      { to: '/terminal', label: 'Desk reżimu' },
    ],
    formKicker: 'INTAKE',
    formTitle: 'Wyślij krótki brief',
    formBody: 'Firma, problem, ograniczenie. Odpowiadamy sami.',
    formName: 'Imię',
    formFirm: 'Firma',
    formEmail: 'Email',
    formNeed: 'Czego potrzebujesz',
    formNeedPlaceholder: 'Wybierz mandat',
    formMessage: 'Brief',
    formSend: 'Wyślij brief',
    formSending: 'Wysyłanie…',
    formOk: 'Doszło. Odezwiemy się.',
    formErr: 'Nie udało się stąd wysłać — użyj linku mail, dojdzie tak samo.',
    formMail: 'Napisz mailem →',
    formNote: 'Poufne. Bez kolejki sprzedażowej. Jeśli brief nie pasuje, powiemy.',
    needs: [
      { id: 'strategy', label: 'Projekt strategii' },
      { id: 'regime', label: 'Reżim / overlay' },
      { id: 'risk', label: 'Ryzyko / protokół drawdownu' },
      { id: 'portfolio', label: 'Konstrukcja portfela' },
      { id: 'retain', label: 'Research na retainerze' },
      { id: 'other', label: 'Coś innego — wyjaśnię' },
    ],
    ctaLine: 'Jeśli pytanie już nie daje spać, zapisz je.',
  },
};
